import React, { useEffect } from 'react';
import { ConversationSidebar } from '@/components/Conversation/ConversationSidebar';
import { ConversationMessage } from '@/services/conversationService';
import {
  financeV2HistoryPanelClassName,
  financeV2HistoryPanelCss,
} from '../../styles/repo2Brand';

interface FinanceConversationLayoutProps {
  children: React.ReactNode;
  isSidebarOpen: boolean;
  onCloseSidebar: () => void;
  onSelectConversation: (conversationId: string, messages: ConversationMessage[], meta?: { dataSourceName?: string }) => void;
  onStartNewConversation: () => void;
  currentConversationId?: string;
}

export function FinanceConversationLayout({
  children,
  isSidebarOpen,
  onCloseSidebar,
  onSelectConversation,
  onStartNewConversation,
  currentConversationId,
}: FinanceConversationLayoutProps) {
  useEffect(() => {
    if (!isSidebarOpen) return undefined;

    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onCloseSidebar();
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isSidebarOpen, onCloseSidebar]);

  return (
    <div className="relative flex h-full min-h-0 w-full overflow-hidden">
      {isSidebarOpen && (
        <>
          <div
            className="absolute inset-0 z-40"
            onClick={onCloseSidebar}
            aria-hidden="true"
          />
          <div className={financeV2HistoryPanelClassName}>
            <style>{financeV2HistoryPanelCss}</style>
            <ConversationSidebar
              isOpen={isSidebarOpen}
              onClose={onCloseSidebar}
              onSelectConversation={onSelectConversation}
              onStartNewConversation={onStartNewConversation}
              currentConversationId={currentConversationId}
              variant="financeV2"
            />
          </div>
        </>
      )}

      <div className="flex-1 flex min-h-0 flex-col min-w-0 relative">
        <div className="flex-1 flex flex-col min-h-0 overflow-hidden">
          {children}
        </div>
      </div>
    </div>
  );
}
